import type { PropsWithChildren } from 'react';
import React from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import { useCommonFcm } from 'src/app/shared/hooks/commonFcm';
import { isLoading } from 'src/app/shared/utils/async';

import { prefetch } from './prefetch';
import type { DefaultLayoutProps } from './shared/types';
import { LayoutV1 } from './v1';
import { LayoutV2 } from './v2';

export const DefaultLayout = withPrefetchedData(
	({
		children,
		...props
	}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
		const commonFcm = useCommonFcm();

		if (isLoading(commonFcm)) {
			return <Loader size="m" my={256} mx="auto" />;
		}

		const Layout = commonFcm.values.frameRelaunch ? LayoutV2 : LayoutV1;

		return <Layout {...props}>{children}</Layout>;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => {
			await prefetch(context);
		},
	},
);

// FIXME temporary for error page
export const DefaultLayoutV1 = withPrefetchedData(
	({
		children,
		...props
	}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
		return <LayoutV1 {...props}>{children}</LayoutV1>;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => {
			await prefetch(context);
		},
	},
);
